import React from "react";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getDocument,
  getDocumentShow,
  clearErrors,
} from "../../redux/Actions/documentAction";
import { getDocumentTypeOption } from "../../redux/Actions/documentTypeAction";
import { getStoreItems } from "../../redux/Actions/storeAction";
import {
  updateContractTest,
  cancelDocument,
  deleteContractItemTest,
  sendContractEmailTest,
  updateContractItemTest,
  createContractItemTest,
  addContractDocument,
} from "../../redux/Actions/orderContractAction";
// import DocumentModal from "./Items/DocumentModal";
import ContentBlock from "../Layout/ContentBlock";
import TableColumnDocuments from "./items/TableColumnDocuments";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import { CheckBoxInput, SelectForm } from "../common/Buttons";
import ListOfDocumentsModal from "./items/ListOfDocumentsModal";
import DocumentAddModal from "./items/documentAddModal";
import Pagination from "../../components/Dashboard/items/Pagination";
import InputText from "../orders/accepted_orders/InputFilter";
import RangePickerComp from "../common/RangePickerComp";
import SwitchComp from "../common/SwitchComp";
import RegularOrderChildren from "../common/GlobalModals/Orders/RegularOrderChildren";
import { getOrder } from "../../redux/Actions/orderAction";

import { Select } from "antd";
const { Option } = Select;

import moment from "moment";
import Axios from "axios";
import { AlertSuccess, AlertError } from "../common/Alerts";
import { formatDatePlus } from "../../helpers/Utils";
import { getOrdersShopsOptions } from "../../redux/Actions/ordershopsAction";
import { Label, TextInput } from "../globals";

const initialFilters = {
  client: "",
  email: "",
  date: ["", ""],
  phone: "",
  sf_number: "",
  number: "",
  who_created: "",
  plan: undefined,
  accord_shop: undefined,
  canceled: false,
  info: false,
  sent: false,
  payment_status: undefined,
  id_number: "",
  category: "",
  model: "",
  manufacturer: "",
};

const PAYMENT_STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: "paid", label: "Paid" },
  { value: "unpaid", label: "Unpaid" },
];
class ListOfDocuments extends React.Component {
  constructor() {
    super();
    this.state = {
      requiredId: 0,
      requiredOrderId: 0,
      page: 1,
      pageCount: 100,
      paramsFilter: "",
      checkedArray: [],
      checkedAll: false,
      // documents: [],
      stores: [],
      documentType: [],
      documentPlan: [],
      openAddModal: false,
      created: false,
      filter: initialFilters,
    };
    this.modalRef = React.createRef();
  }

  componentDidMount() {
    this.props.getDocument(
      this.state.page,
      this.state.pageCount,
      this.state.paramsFilter
    );
    this.props.getDocumentTypeOption().then((res) => {
      if (res.data !== undefined || Object.keys(res.data).length !== 0) {
        let documentType = [];
        let documentPlan = [];
        res.data.forEach((item) => {
          documentType.push({
            value: item.id,
            label: item.name,
            order_shop_id: item.order_shop_id,
          });
          item.document_plans.forEach((planItem) =>
            documentPlan.push({
              value: planItem.id,
              label: planItem.name,
              type: planItem.document_type_id,
              document_type_id: planItem.document_type_id,
              cost: planItem.cost,
              percentage: planItem.percentage,
            })
          );
        });
        this.setState({
          documentType,
          documentPlan,
        });
      }
    });
    this.props.getStoreItems(1, 1000);
    getOrdersShopsOptions().then((res) => {
      if (res.success) {
        this.setState({
          stores: res.data,
        });
      }
    });
  }
  componentDidUpdate(_, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.props.getDocument(
        this.state.page,
        this.state.pageCount,
        this.state.paramsFilter
      );
    }
  }
  getDateFormat = (date) => {
    var d = moment(date);
    return date && d.isValid() ? d : "";
  };

  filterChange = (e, date) => {
    if (date) {
      this.setState(
        {
          filter: {
            ...this.state.filter,
            [date]: e,
          },
        },
        () => this.onFilter()
      );
    } else {
      this.setState({
        filter: {
          ...this.state.filter,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  delayOnFilter = () => {
    if (this.props.loading_documents) {
      return setTimeout(() => {
        return this.delayOnFilter();
      }, 1000);
    }
    this.onFilter();
  };

  onFilter = () => {
    if (this.props.loading_documents) {
      return this.delayOnFilter();
    }
    let filterParams = [];
    if (this.state.filter.client.length > 0) {
      let clientArray = this.state.filter.client.split(" ");
      clientArray.forEach((item) => {
        filterParams.push(`&q[customer_cont_any]=${item}`);
      });
    }
    if (this.state.filter.email.length > 0)
      filterParams.push(`&q[email_cont]=${this.state.filter.email}`);
    if (this.state.filter.date[0].length > 0)
      filterParams.push(`&q[buy_date_gteq]=${this.state.filter.date[0]}`);

    if (this.state.filter.date[1].length > 0)
      filterParams.push(
        `&q[buy_date_lt]=${formatDatePlus(this.state.filter.date[1])}`
      );

    if (this.state.filter.phone.length > 0) {
      let phoneNumber = this.state.filter.phone;
      if (this.state.filter.phone.search(/[\[\]?*+|{}\\()@.\n\r]/) != -1) {
        phoneNumber = phoneNumber.split("+").join("");
      }
      filterParams.push(`&q[phone_i_cont_any]=${phoneNumber}`);
    }

    if (this.state.filter.sf_number.length > 0)
      filterParams.push(
        `&q[invoice_number_cont]=${this.state.filter.sf_number}`
      );
    if (
      this.state.filter.accord_shop !== undefined &&
      this.state.filter.accord_shop.length > 0
    ) {
      if (this.state.filter.accord_shop === "ONLINE") {
        filterParams.push(`&q[store_id_null]=true`);
      } else {
        filterParams.push(
          `&q[store_name_cont]=${this.state.filter.accord_shop}`
        );
      }
    }
    if (this.state.filter.who_created.length > 0)
      filterParams.push(`&q[user_title_cont]=${this.state.filter.who_created}`);

    if (this.state.filter.plan !== undefined)
      filterParams.push(`&q[document_plan_id_eq]=${this.state.filter.plan}`);
    // if (this.state.filter.status !== undefined)
    //   filterParams.push(`&q[total_paid_eq]=${this.state.filter.status}`);

    if (this.state.filter.canceled) {
      filterParams.push(`&q[canceled_at_not_null]=true`);
    } else {
      filterParams.push(`&q[canceled_at_null]=true`);
    }
    if (this.state.filter.info) {
      filterParams.push(`&q[info_eq]=true`);
    }
    if (this.state.filter.sent) {
      filterParams.push(`&q[sent_eq]=true`);
    }
    if (this.state.filter.payment_status) {
      filterParams.push(`&q[payment_status_eq]=${this.state.filter.payment_status}`);
    }
    if (this.state.filter.number.length > 0) {
      filterParams.push(`&q[number_i_cont_any]=${this.state.filter.number}`);
    }

    if (this.state.filter.id_number) {
      filterParams.push(
        `&q[contract_items_id_number_i_cont_any]=${this.state.filter.id_number}`
      );
    }
    if (this.state.filter.category) {
      filterParams.push(
        `&q[contract_items_category_i_cont_any]=${this.state.filter.category}`
      );
    }
    if (this.state.filter.model) {
      filterParams.push(
        `&q[contract_items_model_i_cont_any]=${this.state.filter.model}`
      );
    }
    if (this.state.filter.manufacturer) {
      filterParams.push(
        `&q[contract_items_manufacturer_i_cont_any]=${this.state.filter.manufacturer}`
      );
    }
    this.setState(
      {
        paramsFilter: filterParams.join(""),
        page: 1,
      },
      () => this.reloadData(filterParams.join(""))
    );
  };

  reloadData = (data) => {
    this.props.getDocument(this.state.page, this.state.pageCount, data);
  };

  onAction = (index) => {
    this.setState({
      requiredId: index,
    });
  };

  setPagination = (page) => {
    this.setState({
      page,
    });
  };
  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };

  handleKeyDown = (e) => {
    if (e.key == "Enter") {
      this.onFilter();
    }
  };

  handleCheckboxChange = (value) => {
    const currentIndex = this.state.checkedArray.indexOf(value);
    const newChecked = [...this.state.checkedArray];
    const myData = this.props.documents;

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    let variableAll = myData.length === newChecked.length;

    this.setState({
      checkedArray: newChecked,
      checkedAll: variableAll,
    });
  };

  handleCheckboxAll() {
    const myData = this.props.documents;
    const newChecked = [...this.state.checkedArray];
    let newArray = [];
    if (myData.length === newChecked.length) {
      this.setState({
        checkedAll: false,
        checkedArray: [],
      });
    } else {
      myData.forEach((item) => newArray.push(item.id));
      this.setState({
        checkedAll: true,
        checkedArray: newArray,
      });
    }
  }

  onEdit = (index, id) => {
    this.setState({
      requiredId: index,
    });
    this.props.getDocumentShow(id);
  };

  openModal = () => {
    this.setState({
      openAddModal: true,
    });
  };

  createContract = (id, postVariables) => {
    return this.props.addContractDocument(id, postVariables).then((res) => {
      if (res !== undefined) {
        if (res.data) {
          document.getElementById("modalClose").click();
          document.getElementById(res.data.id).click();
          this.setState({
            created: true,
          });
        }
        return true;
      }
    });
  };

  exportContracts = (action) => {
    let url;
    if (action == "selected") {
      url = "/api/v1/contracts/download_summary";
    } else if (action == "all") {
      url = `/api/v1/contracts/download_summary_all?${this.state.paramsFilter}`;
    }
    Axios({
      url: url,
      method: "POST",
      responseType: "blob", // important
      headers: { Accept: "application/vnd.ms-excel" },
      data: {
        download_summary: this.state.checkedArray,
      },
    }).then((response) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");

      link.href = downloadUrl;

      link.setAttribute("download", `${"Contract_excel"}.xlsx`); //any other extension

      document.body.appendChild(link);

      link.click();

      link.remove();
    });
  };

  exportContractsPpg = (action) => {
    let url;
    if (action == "selected") {
      url = "/api/v1/contracts/download_ppg_grid";
    } else if (action == "all") {
      url = `/api/v1/contracts/download_ppg_grid_all?${this.state.paramsFilter}`;
    }
    Axios({
      url: url,
      method: "POST",
      responseType: "blob", // important
      headers: { Accept: "application/vnd.ms-excel" },
      data: {
        download_summary: this.state.checkedArray,
      },
    }).then((response) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");

      link.href = downloadUrl;

      link.setAttribute("download", `${"ppg_grid"}.xlsx`); //any other extension

      document.body.appendChild(link);

      link.click();

      link.remove();
    });
  };

  clearFilter = () => {
    this.setState(
      {
        filter: initialFilters,
      },
      () => this.reloadData("")
    );
  };

  renderCustomButton = () => {
    return (
      <>
        {["admin", "accounting"].includes(this.props.auth.role) && (
          <div className="dropdown">
            <button
              className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Export
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button
                className="dropdown-item"
                onClick={() => this.exportContracts("selected")}
              >
                Export selected
              </button>
              <button
                className="dropdown-item"
                onClick={() => this.exportContracts("all")}
              >
                Export all
              </button>
              <button
                className="dropdown-item"
                onClick={() => this.exportContractsPpg("selected")}
              >
                export selected PPG
              </button>
              <button
                className="dropdown-item"
                onClick={() => this.exportContractsPpg("all")}
              >
                Export all PPG
              </button>
            </div>
          </div>
        )}
      </>
    );
  };

  orderModal = (order_id, id) => {
    this.setState({
      requiredOrderId: order_id,
    });
    this.props.getOrder(id);
    this.modalRef.current.openModal("OrderShowModal");
  };
  render() {
    const textOfDiv = (
      <div>
        <span className="filterMenuText first">Amount of contracts:</span>
        <span className="firstLength">
          {this.props.total_price} {"\u20AC"}
        </span>
      </div>
    );
    return (
      <Container
        location={{
          locationName: "Documents",
          locationUrl: this.props.match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            totals={this.props.totals}
            length={this.props.documents.length}
            customText={textOfDiv}
            onChangeCountPage={this.setPageCount}
            countPage={this.state.pageCount}
            text2="Documents"
          />
        </ContentBlock>
        <AlertSuccess alertId={"order-s"} />
        <AlertError alertId={"order-e"} />
        <ContentBlock containerClass="py-1">
          <TableFilterBox
            filterText={"Export"}
            add={() => this.openModal()}
            button1={this.renderCustomButton()}
            clearFilter={() => this.clearFilter()}
            // button1_text={`Kontraktų suma: ${this.props.total_price}`}
          >
            <div className="px-1">
              <div className="form-group order-input-form-group">
                <Label className="text-sm-label">Date of purchase</Label>
                <div>
                  <RangePickerComp
                    placeholder={["Start time", "End time"]}
                    style={{ width: 250 }}
                    value={[
                      this.getDateFormat(this.state.filter.date[0]),
                      this.getDateFormat(this.state.filter.date[1]),
                    ]}
                    onChange={(_, args) => this.filterChange(args, "date")}
                  />
                </div>
              </div>
            </div>

            <div className="px-1">
              <InputText
                number="1"
                name="client"
                style={{ width: "165px", fontSize: "0.75rem" }}
                placeholder="Firstname, Lastname"
                value={this.state.filter.client}
                onKeyDown={this.handleKeyDown}
                onChange={(e) => this.filterChange(e)}
              />
            </div>
            <div className="px-1">
              <InputText
                number="1"
                name="email"
                style={{ width: "165px", fontSize: "0.75rem" }}
                placeholder="E.mail"
                value={this.state.filter.email}
                onKeyDown={this.handleKeyDown}
                onChange={(e) => this.filterChange(e)}
              />
            </div>
            <div className="px-1">
              <InputText
                number="1"
                name="phone"
                style={{ width: "165px", fontSize: "0.75rem" }}
                placeholder="Phone number"
                onKeyDown={this.handleKeyDown}
                value={this.state.filter.phone}
                onChange={(e) => this.filterChange(e)}
              />
            </div>
            {this.props.auth.role == "admin" && (
              <div className="px-1">
                <InputText
                  number="1"
                  name="number"
                  style={{ width: "165px", fontSize: "0.75rem" }}
                  placeholder="Number"
                  onKeyDown={this.handleKeyDown}
                  value={this.state.filter.number}
                  onChange={(e) => this.filterChange(e)}
                />
              </div>
            )}
            <div className="px-1">
              <InputText
                number="1"
                name="sf_number"
                style={{ width: "165px", fontSize: "0.75rem" }}
                placeholder="Purchase document number"
                onKeyDown={this.handleKeyDown}
                value={this.state.filter.sf_number}
                onChange={(e) => this.filterChange(e)}
              />
            </div>
            {this.props.auth.role !== "store_user" && (
              <>
                <div className="px-1">
                  <InputText
                    number="1"
                    name="who_created"
                    style={{ width: "165px", fontSize: "0.75rem" }}
                    placeholder="Worker"
                    onKeyDown={this.handleKeyDown}
                    value={this.state.filter.who_created}
                    onChange={(e) => this.filterChange(e)}
                  />
                </div>
                {/* <div className="px-1">
                  <InputText
                    width={"0.75rem"}
                    number="1"
                    name="accord_shop"
                    placeholder="Pagal parduotuve"
                    onKeyDown={this.handleKeyDown}
                    value={this.state.filter.accord_shop}
                    onChange={(e) => this.filterChange(e)}
                  />
                </div> */}
                {!["store_manager", "store_user"].includes(
                  this.props.auth.role
                ) && (
                  <div className="px-1">
                    <Label className="text-sm-label">Store</Label>
                    <div>
                      <Select
                        placeholder={"Store"}
                        value={this.state.filter.accord_shop}
                        style={{ width: "165px" }}
                        onChange={(e) => this.filterChange(e, "accord_shop")}
                      >
                        {[
                          {
                            id: 1515156,
                            name: "",
                          },
                          { id: 151535, name: "ONLINE" },
                          ...this.props.storeItems,
                        ].map((item) => (
                          <Option key={item.id} value={item.name}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                )}
              </>
            )}
            <div className="px-1">
              <TextInput
                text="Category"
                name="category"
                style={{ width: "165px" }}
                onKeyDown={this.handleKeyDown}
                value={this.state.filter.category}
                onChange={(e) => this.filterChange(e)}
              />
            </div>
            <div className="px-1">
              <TextInput
                text="Model"
                name="model"
                style={{ width: "165px" }}
                onKeyDown={this.handleKeyDown}
                value={this.state.filter.model}
                onChange={(e) => this.filterChange(e)}
              />
            </div>
            <div className="px-1">
              <TextInput
                text="Manufacturer"
                name="manufacturer"
                style={{ width: "165px" }}
                onKeyDown={this.handleKeyDown}
                value={this.state.filter.manufacturer}
                onChange={(e) => this.filterChange(e)}
              />
            </div>
            {["admin", "manager"].includes(this.props.auth.role) && (
              <div className="px-1">
                <InputText
                  number="1"
                  name="id_number"
                  style={{ width: "165px", fontSize: "0.75rem" }}
                  placeholder="Serial number"
                  onKeyDown={this.handleKeyDown}
                  value={this.state.filter.id_number}
                  onChange={(e) => this.filterChange(e)}
                />
              </div>
            )}
            <div className="px-1">
              <SwitchComp
                name="Info"
                placeholder="Info"
                labelClassName="text-sm-label"
                checked={this.state.filter.info}
                onChange={() =>
                  this.setState(
                    {
                      filter: {
                        ...this.state.filter,
                        info: !this.state.filter.info,
                      },
                    },
                    () => this.onFilter()
                  )
                }
              />
            </div>
            <div className="px-1">
              <SwitchComp
                name="Sent"
                placeholder="Sent"
                labelClassName="text-sm-label"
                checked={this.state.filter.sent}
                onChange={() =>
                  this.setState(
                    {
                      filter: {
                        ...this.state.filter,
                        sent: !this.state.filter.sent,
                      },
                    },
                    () => this.onFilter()
                  )
                }
              />
            </div>
            <div className="px-1">
              <SwitchComp
                name="Cancel"
                placeholder="Cancel"
                labelClassName="text-sm-label"
                checked={this.state.filter.canceled}
                onChange={() =>
                  this.setState(
                    {
                      filter: {
                        ...this.state.filter,
                        canceled: !this.state.filter.canceled,
                      },
                    },
                    () => this.onFilter()
                  )
                }
              />
            </div>
            <div className="px-1" style={{ width: 165 }}>
              <SelectForm
                placeholder="Payment status"
                onlyPlaceholder="Payment status"
                selector="documents_payment_status"
                options={PAYMENT_STATUS_OPTIONS}
                value={this.state.filter.payment_status}
                onChange={(value) =>
                  this.setState(
                    {
                      filter: {
                        ...this.state.filter,
                        payment_status: value || undefined,
                      },
                    },
                    () => this.onFilter()
                  )
                }
              />
            </div>
          </TableFilterBox>
          <div>
            <ContentValidation
              loader={this.props.loading_documents}
              array={this.props.documents}
            >
              <div className="table-responsive">
                <table className="table table-sm table-hover mt-3">
                  <thead>
                    <tr className="text-muted">
                      <th className="text-black">
                        <div className="d-flex">
                          <CheckBoxInput
                            type="checkbox"
                            color="#f7951e"
                            checked={this.state.checkedAll}
                            onChange={() => this.handleCheckboxAll()}
                          />
                        </div>
                      </th>
                      <th className="text-black"></th>
                      <th className="text-black">Created date</th>
                      <th className="text-black">Purchase date</th>
                      {this.props.auth.role !== "store_user" && (
                        <th className="text-black">Created by</th>
                      )}
                      <th className="text-black">Info</th>
                      <th className="text-black">Sent</th>
                      <th className="text-black">Cancel</th>
                      <th className="text-black">Service</th>
                      <th className="text-black">Store</th>
                      <th className="text-black">Numer</th>
                      <th className="text-black">Client</th>
                      <th className="text-black">E.mail</th>
                      <th className="text-black">Phone number</th>
                      <th className="text-black">Purchase document number</th>
                      <th className="text-black">Valid from </th>
                      <th className="text-black">Valid until</th>
                      <th className="text-black">Sum</th>
                      <th className="text-black">Reduced price</th>
                      <th className="text-black">Payment status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.documents.map((item, index) => {
                      return (
                        <TableColumnDocuments
                          key={index}
                          index={index}
                          id={item.id}
                          item={item}
                          onAction={this.onAction}
                          role={this.props.auth.role}
                          onDelete={this.props.deleteDocument}
                          handleCheckboxChange={this.handleCheckboxChange}
                          checkedArray={this.state.checkedArray}
                          onEdit={this.onEdit}
                          orderModal={this.orderModal}
                        />
                      );
                    })}
                  </tbody>
                </table>
                <Pagination
                  setPagination={this.setPagination}
                  page={this.state.page}
                  totals={this.props.totals}
                  pageCount={this.state.pageCount}
                />
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>
        <DocumentAddModal
          stores={this.state.stores}
          openAddModal={this.state.openAddModal}
          submitedNew={this.state.submitedNew}
          documentType={this.state.documentType}
          documentPlan={this.state.documentPlan}
          addContractDocument={this.createContract}
          onSubmitContract={this.onSubmitContract}
          errors={this.props.errors}
        />
        {this.props.documents.length > 0 && (
          <ListOfDocumentsModal
            auth={this.props.auth}
            createdNew={this.state.created}
            stopCreateNew={(stop) => this.setState({ created: false })}
            objectData={this.props.document}
            documentType={this.state.documentType}
            documentPlan={this.state.documentPlan}
            contract_emails={this.props.document.contract_emails}
            updateContract={this.props.updateContractTest}
            deleteContractItem={this.props.deleteContractItemTest}
            sendContractEmail={this.props.sendContractEmailTest}
            updateContractItemTest={this.props.updateContractItemTest}
            createContractItemTest={this.props.createContractItemTest}
            cancelDocument={this.props.cancelDocument}
            getDocumentShow={this.props.getDocumentShow}
          />
        )}
        <div id="modal-roots" />
        <RegularOrderChildren
          ref={this.modalRef}
          requiredOrderId={this.state.requiredOrderId}
        />
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth.user,
  document: state.documents.document,
  storeItems: state.store.storeItems,
  documents: state.documents.documents,
  loading_documents: state.documents.loading_documents,
  totals: state.documents.totals,
  total_price: state.documents.total_price,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getOrder,
  getDocument,
  getStoreItems,
  cancelDocument,
  getDocumentShow,
  getDocumentTypeOption,
  updateContractTest,
  deleteContractItemTest,
  sendContractEmailTest,
  updateContractItemTest,
  createContractItemTest,
  addContractDocument,
  clearErrors,
})(ListOfDocuments);
